
import React, { useState, useEffect } from 'react'
import { Popup, Mask, TextArea } from 'antd-mobile'
import AiNavigationBar from '../AiNavigationBar'
import ReactDOM from 'react-dom'
import icon001 from './image/icon001.png'
import icon002 from './image/icon002.png'
import icon003 from './image/icon003.png'
import activity_icon20 from './image/activity_icon20.png'
import wxUrlShare from '../../utils/nativeFun/wxUrlShare'
import './index.scss'

interface Item {
    name?: string,
    content?: string
}

interface AiShareProps {
    visible?:boolean //是否显示
    url?: string //h5地址
    title?: string //标题
    description?: string //描述
    imgUrl?: string //分享icon
    friends?: string //分享盆友圈文案
    custom?: boolean //是否自定义方法
    copy?: boolean //是否需要配置文案
    defaultValue?: '' //输入框默认文案
    onCancel?: () => void
    onShare?:(data:any) => void
    onShareFriends?:() => void //自定义分享盆友圈
    onCustomShare?:(judge) => void //自定义分享方法
    onSave?:(value?:string) => void //保存
    dataList?: Item[]
}

const AiShare: React.FC<AiShareProps> = ({ visible, url, title, description, imgUrl = '', friends = '', custom = false, copy = false, defaultValue = '', dataList = [], ...props }) => {
    /**
     * 网页分享
     * @param url  地址
     * @param title 标题
     * @param description  描述
     * @param imgUrl  分享icon
     * @param judge  类型选择 好友-0 朋友圈-1
     * wxUrlShare(String url, String title, String description, String imgUrl, int judge)
     */
    const handleShare = (judge) => {
        try {
            if( !!custom && props?.onCustomShare ) {
                props.onCustomShare(judge)
                props?.onCancel && props.onCancel()
                return
            }
            if( judge === 1 && !friends && props?.onShareFriends ) {
                props?.onShareFriends()
                props?.onCancel && props.onCancel()
                return
            }
            wxUrlShare(url, title, description, imgUrl, judge, () => {
                props?.onShare && props.onShare({
                    url, 
                    title, 
                    description, 
                    imgUrl, 
                    judge,
                    friends
                })
                props?.onCancel && props.onCancel()
                return
            })
            props?.onShare && props.onShare({
                msg:'分享失败'
            })
            props?.onCancel && props.onCancel()
        } catch (error) {
            props?.onShare && props.onShare({
                msg:'分享失败'
            })
            props?.onCancel && props.onCancel()
        }
    }
    const [value, setValue] = useState<any>(undefined)
    const [maskVisible, setMaskVisible] = useState<boolean>(false)
    const onChange = _value => {
        setValue(_value)
    }
    useEffect(() => {
        setValue(defaultValue)
    },[defaultValue])
    const onSave = () => {
        setMaskVisible(false)
        props?.onSave && props?.onSave(value || '')
    }
    return <div>
        <Popup
            visible={visible}
            onMaskClick={props?.onCancel && props.onCancel}
            bodyStyle={{
                borderTopLeftRadius: '.2133rem',
                borderTopRightRadius: '.2133rem',
                minHeight: '3rem',
            }}
        >
            <div className='share-wrapper'>
                <div className='share-wrapper-container'>
                    <img src={activity_icon20} alt="" onClick={props?.onCancel && props.onCancel} />
                    <div className='share-wrapper-container-item' onClick={() => handleShare(0)}>
                        <div><img src={icon001} alt="" /></div>
                        <p>微信</p>
                    </div>
                    <div className='share-wrapper-container-item' onClick={() => handleShare(1)}>
                        <div><img src={icon002} alt="" /></div>
                        <p>朋友圈</p>
                    </div>
                    {!!copy && <div className='share-wrapper-container-item' onClick={() => setMaskVisible(true)}>
                        <div><img src={icon003} alt="" /></div>
                        <p>文案配置</p>
                    </div>}
                </div>
                {/* <p className='border-top' onClick={props?.onCancel && props.onCancel}>取消</p> */}
            </div>
        </Popup>
        <Mask visible={maskVisible} style={{'--z-index':99999}}>        
            <AiNavigationBar onBack={() => setMaskVisible(false)} title='分享文案' bottomBorder silent extra={<div onClick={onSave}>保存</div>} />
            <div className='copy-wrapper'>
                <div className='copy-wrapper-list-text-area'><TextArea placeholder='请输入文案' defaultValue={defaultValue} value={value} onChange={onChange} style={{'--font-size':'.32rem','--placeholder-color':'#1A1B1C'}} /></div>
                <div className='copy-wrapper-list'>
                    {(dataList || []).map((item, index) => (
                        <div className='copy-wrapper-list-item' key={index}>
                            <span>{item.name}：</span>
                            <i>{item?.content}</i>
                        </div>
                    ))}
                </div>
            </div>
        </Mask>
    </div>
}


export default AiShare


export const share = (options:AiShareProps) => {
    const _div = document.getElementById('share-modal-id')
    if (_div) {
        ReactDOM.render(null, _div)
        document.body.removeChild(_div)
    }
    let div = document.createElement('div')
    div.id = 'share-modal-id'
    document.body.appendChild(div);
    const ShareHooks = (props) => {
        const [visible, setVisible] = useState(true)
        const onCancel = () => {
            options?.onCancel && options.onCancel()
            setVisible(false)
            share.destroy()
        }
        const onCustomShare = (judge) => {
            if( !options?.custom ) {
                return
            }
            setVisible(false)
            share.destroy()
            options?.onCustomShare && options.onCustomShare(judge)
        }
        const onShareFriends = () => {
            setVisible(false)
            share.destroy()
            options?.onShareFriends && options.onShareFriends()
        }
        useEffect(() => {
            setVisible(true)
        }, [props]);
        const onShare = (data) => {
            try {
                setVisible(false)
                share.destroy()
                options?.onShare && options.onShare(data)
            } catch (error) {
                setVisible(false)
            }
        }
        return <AiShare visible={visible} {...options} onCustomShare={onCustomShare} onShareFriends={onShareFriends} onCancel={onCancel} onShare={onShare} />
    }

    ReactDOM.render(<ShareHooks />, div)
}

share.destroy = () => {
    const div = document.getElementById('share-modal-id')
    if (div) {
        ReactDOM.render(null, div)
        document.body.removeChild(div)
    }
}

